import { useEffect, useState } from "react";
import Api from '../../component/Api'
import { toast } from "react-toastify";
import './Admin.css';
import Loading from "../../component/loader/Loading";

const Admin = () => {

    const [views, setViews] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [userList, setUserList] = useState([]);

    useEffect(() => {
        loadUsers();
        fetch(`${Api}/views`)
            .then(res => {
                return res.json();
                // console.log(res.json())
            }).then(resq => {
                setViews(resq.counter)
            }).catch((err) => {
                toast.error('Failed :' + err.message);
            });
    }, []);
    if (views !== null) {
        console.log(views)
    }

    const loadUsers = () => {
        setIsLoading(true);
        fetch(`${Api}/user`).then(res => {
            return res.json();
        }).then(res => {
            // console.log(res)
            setUserList(res)
            setIsLoading(false);
        }).catch((err) => {
            toast.error('Failed :' + err.message);
        });
    }

    // const loadDoes = (id) => {

    //     fetch(`${Api}/toDo?userId=${id}`).then(res => {
    //         return res.json();
    //     }).then(res => {
    //         // console.log(res)
    //         setDataDo(res)
    //     });

    //     setDataDo.map((item) => {
    //         fetch(`${Api}/toDo/${item.id}`, {
    //             method: "Delete",
    //             headers: { 'content-type': 'application/json' },

    //         }).then((res) => {
    //             console.log("deleted")
    //         }).catch((err) => {
    //             toast.error('Failed :' + err.message);
    //         });
    //     })

    //     toast.success('Deleted successfully.')
    // }

    const handleremove = (id) => {
        if (window.confirm("Do you want to delete this user ? ")) {
            setIsLoading(true);
            fetch(`${Api}/user/${id}`, {
                method: "Delete",
                headers: { 'content-type': 'application/json' },

            }).then((res) => {
                toast.success('Deleted successfully.')
                setTimeout(() => loadUsers(), 100)
                setIsLoading(false);

            }).catch((err) => {
                toast.error('Failed :' + err.message);
                setIsLoading(false);
            });

        }
        // loadDoes(id);


    }


    return (
        <div className="container text-center ">
            {isLoading ? <Loading /> : " "}
            <h1 className="mt-5 text-primary">welcome Admin</h1>
            <div className="mx-2">number of views {views} </div>
            <div className="card mt-5">
                <div className="card-header ">
                    <h3>User Listing</h3>
                </div>
                <div className="card-body scroll">
                    <table className="table table-bordered ">
                        <thead className="bg-dark text-white">
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody >
                            {userList &&
                                userList.map((item, index) => {
                                    if (index !== 0) return (
                                        <tr key={index}>
                                            <td>{index}</td>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>
                                                <button onClick={() => handleremove(item.id)} className="btn btn-danger Admin">Remove</button>
                                            </td>
                                        </tr>
                                    )
                                }

                                )
                            }

                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    );
}

export default Admin;